// ============================================================================
// Diccionario ESPAÑOL (idioma por defecto). Es la FUENTE de las claves: los
// demás idiomas se tipan contra este archivo, así que una clave que falte en
// inglés es un error de typecheck, no un texto vacío en pantalla.
//
// Los textos que ya existían se copiaron TAL CUAL (con español nada cambia).
// Interpolación: {nombre} se reemplaza por vars.nombre.
// ============================================================================
export const es = {
  // --- App / shell -----------------------------------------------------------
  'app.subtitulo': 'Sistema de gestión de restaurantes',
  'app.cargando': 'Cargando…',
  'app.cargandoModulo': 'Cargando módulo…',

  // --- Navegación (sidebar + barra móvil) -----------------------------------
  'nav.dashboard': 'Dashboard',
  'nav.kpis': 'Estadísticas',
  'nav.orders': 'Pedidos',
  'nav.reservations': 'Reservaciones',
  'nav.tables': 'Mesas',
  'nav.menu': 'Carta',
  'nav.combos': 'Combos',
  'nav.inventory': 'Inventario',
  'nav.purchases': 'Costos y Gastos',
  'nav.activos': 'Activos y Consumibles',
  'nav.aprobaciones': 'Aprobaciones',
  'nav.misSolicitudes': 'Mis solicitudes',
  'nav.contabilidad': 'Contabilidad',
  'nav.billing': 'Facturación',
  'nav.payments': 'Pagos',
  'nav.enviosMu': 'Domicilios MU',
  'nav.credenciales': 'Llaves y credenciales',
  'nav.terceros': 'Terceros',
  'nav.users': 'Usuarios',
  'nav.reports': 'Reportes',
  'nav.params': 'Parametrización',
  'nav.legalEntities': 'Entidades Legales',
  'nav.cortesias': 'Cortesías',
  'nav.staff': 'Personal',
  'nav.ratings': 'Calificaciones',
  'nav.notificaciones': 'Notificaciones',
  'nav.features': 'Features',
  'nav.debug': 'Depuración',
  'nav.technicalDocs': 'Docs Técnicas',
  'nav.inicio': 'Inicio',
  'nav.mas': 'Más',
  'nav.masOpciones': 'Más opciones',

  // --- Sidebar ---------------------------------------------------------------
  'sidebar.cerrarMenu': 'Cerrar menú',
  'sidebar.expandirMenu': 'Expandir menú',
  'sidebar.minimizarMenu': 'Minimizar menú',
  'sidebar.minimizar': 'Minimizar',

  // --- Barra superior --------------------------------------------------------
  'top.abrirMenu': 'Abrir menú',
  'top.notificaciones': 'Notificaciones',
  'top.sede': 'Sede: {sede}',
  'top.menuUsuario': 'Menú de usuario',
  'top.sinAlertas': 'No hay alertas. ✨',
  'top.reservasProximas': 'Reservas próximas',
  'top.haceMin': 'hace {n} min',
  'top.ahora': 'ahora',
  'top.enMin': 'en {n} min',
  'top.pers': 'pers',
  'top.descartarReserva': 'Descartar reserva',
  'top.inventarioBajo': 'Inventario bajo mínimo',
  'top.min': 'mín',
  'top.descartar': 'Descartar',
  'top.limpiarInventario': 'Limpiar inventario',
  'top.verInventario': 'Ver inventario',
  'top.pantallaCompleta': 'Pantalla completa',
  'top.salirPantallaCompleta': 'Salir de pantalla completa',
  'top.cambiarRol': 'Cambiar rol (dev)',
  'top.ocultarCambiarRol': 'Ocultar Cambiar rol',
  'top.cerrarSesion': 'Cerrar sesión',
  'top.idioma': 'Idioma',
  'top.monedaChip': '{moneda} · sin FE',
  'top.monedaChipTitulo': 'Moneda {moneda}: la facturación electrónica DIAN, Bold y Domicilios MU están desconectados. Se cambia en Features.',

  // --- Roles -----------------------------------------------------------------
  'rol.gerente_operativo': 'Gerente Operativo',
  'rol.gerente_administrativo': 'Gerente Administrativo',
  'rol.jefe_operaciones': 'Jefe de Operaciones',
  'rol.jefe_administrativo': 'Jefe Administrativo',
  'rol.contador': 'Contaduría',
  'rol.cajera': 'Cajero',
  'rol.mesero': 'Mesero',
  'rol.desarrollador': 'Desarrollador',

  // --- Búsqueda global (barra superior) ---------------------------------------
  'busqueda.global': 'Búsqueda global',
  'busqueda.atajo': 'Buscar (⌘K)',
  'busqueda.boton': 'Buscar en todo Salonika…',
  'busqueda.botonCorto': 'Buscar…',
  'busqueda.placeholder': 'Busca platos, items, mesas, pedidos, reservas, facturas…',

  // --- Login -----------------------------------------------------------------
  'login.usuario': 'Usuario',
  'login.usuarioPlaceholder': 'Ingresa tu usuario',
  'login.contrasena': 'Contraseña',
  'login.contrasenaPlaceholder': 'Ingresa tu contraseña',
  'login.entrar': 'Iniciar sesión',

  // --- Moneda / FED desconectado (componentes nuevos) ------------------------
  'regional.fedDesconectadaTitulo': 'Facturación electrónica desconectada',
  'regional.fedDesconectadaTexto': 'La moneda configurada es {moneda}. La DIAN solo factura en COP, así que FED está apagado y las ventas se registran sin factura electrónica. Se cambia en Features (solo desarrollador).',

  // --- Features --------------------------------------------------------------
  'feat.soloDev': 'Este módulo es solo para el rol desarrollador.',
  'feat.flagsActivos': 'Flags activos',
  'feat.escaneosMes': 'Escaneos del mes',
  'feat.intro': 'Flags de la aplicación, presupuesto del escaneo IA e historial de escaneos. (Antes vivía en Depuración.)',
  'feat.funcionesTitulo': 'Funciones de la aplicación',
  'feat.funcionesDesc': 'Activá o desactivá módulos sin redeploy. Los usuarios ven el cambio al recargar.',
  'feat.cargando': 'Cargando…',
  'feat.habilitado': 'Habilitado',
  'feat.deshabilitado': 'Deshabilitado',
  'feat.habilitadoMin': 'habilitado',
  'feat.deshabilitadoMin': 'deshabilitado',
  'feat.flagOk': '✓ {titulo}: {estado} — los usuarios lo ven al recargar.',
  'feat.flagError': 'No se pudo guardar el flag',
  'feat.flag.scan.titulo': 'Escanear factura con IA',
  'feat.flag.scan.desc': 'Botón "Escanear factura" en Costos y Gastos: lee facturas con foto, clasifica el gasto y carga el inventario.',
  'feat.flag.staff.titulo': 'Módulo Personal (turnos)',
  'feat.flag.staff.desc': 'Organización semanal de turnos de trabajadores por sede. Aparece en el menú al activarlo.',
  'feat.flag.ratings.titulo': 'Módulo Calificaciones (QR post-pago)',
  'feat.flag.ratings.desc': 'QR al cobrar cada venta: el comensal califica atención, comida y recomendación desde su celular. Estadísticas solo para superadmin y desarrollador. Add-on pago.',
  'feat.flag.cortesias.titulo': 'Módulo Cortesías',
  'feat.flag.cortesias.desc': 'Botón 🎁 en la mesa: items regalados en $0 al cliente, trackeados (quién/cuándo/valor), salen del inventario y se discriminan en la venta. Incluye el módulo con el histórico.',
  'feat.flag.combos.titulo': 'Módulo Combos',
  'feat.flag.combos.desc': 'Armar paquetes de platos con precio propio (mig. 049). Apagado: el módulo desaparece del menú y no se pueden crear ni editar combos. Los combos ya creados siguen en la carta.',
  'feat.presupuestoConfirmTitulo': '¿Habilitar +5 USD de presupuesto?',
  'feat.presupuestoConfirmTexto': 'Se suma al presupuesto de escaneo de facturas del mes en curso y queda auditado a tu nombre (para facturarlo al cliente).',
  'feat.presupuestoConfirmBoton': 'Habilitar +$5',
  'feat.presupuestoError': 'No se pudo otorgar el extra',
  'feat.presupuestoLinea': 'Presupuesto IA del mes ({mes}): ${gastado} de ${total} USD',
  'feat.presupuestoEscaneos': '{n} escaneos · base ${base}',
  'feat.presupuestoExtras': ' + extras ${extras}',
  'feat.presupuestoAgotado': ' · 🚫 AGOTADO — escaneo bloqueado',
  'feat.presupuestoHabilitando': 'Habilitando…',
  'feat.historialTitulo': 'Historial de escaneos',
  'feat.historialDesc': 'Cada intento con su recorrido real de checkpoints (preparando → IA → analizando → listo), resultado y gasto enlazado.',
  'feat.actualizar': 'Actualizar',
  'feat.historialVacio': 'Sin escaneos registrados aún. (El historial arranca con la migración 029 — los escaneos anteriores no aparecen.)',
  'feat.col.fecha': 'Fecha',
  'feat.col.usuario': 'Usuario',
  'feat.col.proveedor': 'Proveedor leído',
  'feat.col.total': 'Total',
  'feat.col.tipo': 'Tipo',
  'feat.col.lineas': 'Líneas',
  'feat.col.estado': 'Estado',
  'feat.col.detalle': 'Detalle',
  'feat.col.costo': 'Costo',
  'feat.estado.procesando': 'Procesando',
  'feat.estado.listo': 'Listo',
  'feat.estado.confirmado': 'Confirmado',
  'feat.estado.error': 'Error',
  'feat.estado.sinEstado': 'sin estado',
  'feat.gasto': 'gasto #{id}',

  // --- Features: idioma y moneda (nuevo, oct-2026) ---------------------------
  'feat.regionalTitulo': 'Idioma y moneda',
  'feat.regionalDesc': 'Idiomas que cada usuario puede elegir en su menú de usuario, y la moneda de toda la instalación.',
  'feat.idiomasTitulo': 'Idiomas habilitados',
  'feat.idiomasDesc': 'El español siempre está activo. Cada usuario elige su idioma en el menú de usuario de la barra superior.',
  'feat.idiomasParcial': 'Toda la interfaz está traducida. Siguen en español: los mensajes que manda el servidor, los documentos impresos para el cliente o la DIAN (factura, pre-cuenta) y los datos (nombres de platos, categorías, sedes).',
  'feat.idiomaSiempre': 'Siempre activo',
  'feat.idiomasGuardado': '✓ Idiomas habilitados: {lista}.',
  'feat.monedaTitulo': 'Moneda',
  'feat.monedaDesc': 'Una sola moneda para toda la instalación. Solo COP habilita la facturación electrónica DIAN (FED), Bold y Domicilios MU. Los montos guardados no se convierten.',
  'feat.monedaActual': 'Actual',
  'feat.monedaConFE': 'Con facturación electrónica',
  'feat.monedaSinFE': 'Sin facturación electrónica',
  'feat.monedaConfirmTitulo': '¿Cambiar la moneda a {moneda}?',
  'feat.monedaConfirmFuera': 'Se desconectan FED (facturación electrónica DIAN), Bold y Domicilios MU. Las ventas se registran sin factura electrónica.',
  'feat.monedaConfirmVuelta': 'Se reconectan FED, Bold y Domicilios MU con la configuración que ya tenían.',
  'feat.monedaConfirmDatos': 'Los montos NO se convierten: hay {ventas} ventas y {facturas} facturas electrónicas guardadas que pasan a mostrarse en {moneda}.',
  'feat.monedaConfirmBoton': 'Cambiar a {moneda}',
  'feat.monedaCambiada': '✓ Moneda cambiada a {moneda}. Recargando…',
  'feat.error': '✗ {mensaje}',
} as const;

export type Clave = keyof typeof es;
export type Diccionario = Record<Clave, string>;
